// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c1b198d4","644":"314b432e"}[chunkId] + ".chunk.js";
};